import { useLayoutEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import GeneratePage from "./GeneratePage";

/** Links from when Generate also held ideas and recent drafts. */
export function legacyGenerateDestination(search: string, hash: string): string | null {
  const params = new URLSearchParams(search);
  // Generate confirms credit purchases, so a checkout return always stays here.
  if (params.has("credits")) return null;
  if (hash === "#studio-ideas" || params.get("ideas") === "1" || params.get("addSource") === "1") {
    params.delete("ideas");
    const rest = params.toString();
    return `/ideas${rest ? `?${rest}` : ""}`;
  }
  if (hash === "#studio-drafts") return "/created";
  return null;
}

export default function GenerateHomePage() {
  const { activeWorkspaceId } = useAuth();
  const { search, hash, key: navigationKey } = useLocation();
  const legacyDestination = legacyGenerateDestination(search, hash);
  useLayoutEffect(() => {
    // A normal visit should begin at the composer, not inherit the previous
    // page's scroll position.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [navigationKey]);
  if (legacyDestination) return <Navigate to={legacyDestination} replace />;
  return (
    <div
      className="mx-auto max-w-6xl px-4 py-8 sm:px-8 sm:py-12"
      key={activeWorkspaceId}
    >
      <header className="mx-auto mb-8 max-w-3xl text-center">
        <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">
          What will you create today?
        </h1>
      </header>

      <section aria-label="Generate content" className="mx-auto max-w-3xl">
        <GeneratePage embedded inline />
      </section>
    </div>
  );
}
